import { z } from "zod";

/**
 * Error map GLOBAL de Zod en español. Red de seguridad: cualquier esquema que
 * olvide un mensaje custom mostrará estos textos en lugar de los defaults en
 * inglés ("Required", "Expected number, received nan", …). Los mensajes custom
 * de cada esquema siguen teniendo prioridad.
 */
const TYPE_LABELS: Record<string, string> = {
  string: "un texto",
  number: "un número",
  boolean: "un valor sí/no",
  date: "una fecha",
  array: "una lista",
  object: "un objeto",
};

const zodEsErrorMap: z.ZodErrorMap = (issue, ctx) => {
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      if (issue.received === "undefined" || issue.received === "null" || issue.received === "nan") {
        return { message: "Este campo es obligatorio." };
      }
      if (issue.expected === "integer") {
        return { message: "Debe ser un número entero." };
      }
      return {
        message: `Se esperaba ${TYPE_LABELS[issue.expected] ?? "otro tipo de dato"}.`,
      };
    case z.ZodIssueCode.too_small:
      if (issue.type === "string") {
        return issue.minimum === 1
          ? { message: "Este campo es obligatorio." }
          : { message: `Debe tener al menos ${issue.minimum} caracteres.` };
      }
      if (issue.type === "number") {
        return {
          message: issue.inclusive
            ? `Debe ser mayor o igual a ${issue.minimum}.`
            : `Debe ser mayor a ${issue.minimum}.`,
        };
      }
      if (issue.type === "array") {
        return { message: `Selecciona al menos ${issue.minimum} elemento(s).` };
      }
      break;
    case z.ZodIssueCode.too_big:
      if (issue.type === "string") {
        return { message: `Debe tener como máximo ${issue.maximum} caracteres.` };
      }
      if (issue.type === "number") {
        return {
          message: issue.inclusive
            ? `Debe ser menor o igual a ${issue.maximum}.`
            : `Debe ser menor a ${issue.maximum}.`,
        };
      }
      break;
    case z.ZodIssueCode.invalid_string:
      if (issue.validation === "email") {
        return { message: "Ingresa un correo electrónico válido." };
      }
      if (issue.validation === "url") {
        return { message: "Ingresa una URL válida." };
      }
      return { message: "El formato no es válido." };
    case z.ZodIssueCode.invalid_enum_value:
      return { message: "Selecciona una opción válida." };
  }
  return { message: ctx.defaultError };
};

/** Registra el error map global. Llamar UNA vez al arrancar la app. */
export function installZodSpanishErrorMap(): void {
  z.setErrorMap(zodEsErrorMap);
}
